export default __webpack_public_path__ + "static/media/d85fc42bb7f525e72e7b9152d23da02f.png";